import { render, staticRenderFns } from "./award-score.vue?vue&type=template&id=23e9c0b4&scoped=true&"
import script from "./award-score.vue?vue&type=script&lang=js&"
export * from "./award-score.vue?vue&type=script&lang=js&"
import style0 from "./award-score.vue?vue&type=style&index=0&id=23e9c0b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e9c0b4",
  null
  
)

export default component.exports